import { Component } from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './EditorConvertToHTML.scss';

interface EditorConvertToHTMLProps {
  content?: string;
  onSave?: (htmlContent: string) => void;
  cancelEdit?: () => void;
  onContentChange?: (hasChanged: boolean) => void; 
  isSubjectChanged: boolean;
}

interface EditorConvertToHTMLState {
  editorState: EditorState;
}

class EditorConvertToHTML extends Component<EditorConvertToHTMLProps, EditorConvertToHTMLState> {
  initialRawContent: string;

  constructor(props: EditorConvertToHTMLProps) {
    super(props);

    const { content } = props;
    let editorState: EditorState;

    if (content) {
      const blocksFromHtml = htmlToDraft(content);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
      editorState = EditorState.createWithContent(contentState);
    } else {
      editorState = EditorState.createEmpty();
    }

    this.state = {
      editorState,
    };

    this.initialRawContent = JSON.stringify(convertToRaw(editorState.getCurrentContent()));
  }

  onEditorStateChange = (editorState: EditorState): void => {
    this.setState({ editorState }, () => {
      const { onContentChange } = this.props;
      if (onContentChange) {
        onContentChange(this.hasContentChanged());
      }
    });
  };

  handleSave = () => {
    const { onSave, onContentChange } = this.props;
    const { editorState } = this.state;
    const htmlContent = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    onSave && onSave(htmlContent);
    this.initialRawContent = JSON.stringify(convertToRaw(editorState.getCurrentContent()));

    onContentChange && onContentChange(false);
  };

  hasContentChanged = () => {
    const { isSubjectChanged } = this.props;
    const { editorState } = this.state;
    const currentRaw = JSON.stringify(convertToRaw(editorState.getCurrentContent()));
    return currentRaw !== this.initialRawContent || isSubjectChanged;
  };

  handleCancelEdit = () => {
    const { cancelEdit, onContentChange } = this.props;
    cancelEdit && cancelEdit();
    onContentChange && onContentChange(false);
    this.setState({ editorState: EditorState.createEmpty() }, () => {
      onContentChange && onContentChange(false);
    });
  }

  render() {
    const { editorState } = this.state;
    return (
      <div className='h-5'>
        <Editor
          editorState={editorState}
          wrapperClassName="demo-wrapper h-[calc(100vh-440px)] sm:h-[calc(100vh-400px)] min-h-[100px] max-h-[calc(100vh-440px)] m:h-[calc(100vh-440px)] sm:min-h-[150px] sm:max-h-[calc(100vh-400px)]"
          editorClassName="demo-editor h-[calc(100vh-640px)] min-h-[78px] sm:min-h-[100px] max-h-[calc(100vh-640px)] sm:h-[calc(100vh-50px)] sm:min-h-[50px] sm:max-h-[calc(100vh-500px)]"
          onEditorStateChange={this.onEditorStateChange}
        />
        <button
          onClick={this.handleCancelEdit}
          type="button"
          className="text-xs me-3 w-[70px] text-gray-600 btn bg-slate-200 hover:bg-slate-300"
        >
          <span className="align-middle">Cancel</span>
        </button>
        {this.hasContentChanged() && (
          <button
            onClick={this.handleSave}
            type="button"
            className="text-xs w-[70px] text-white btn bg-blue-500 hover:bg-blue-600 hover:text-white"
          >
            <span className="align-middle">Save</span>
          </button>
        )}
      </div>
    );
  }
}

export default EditorConvertToHTML;